<template>
  <div>
    <div class="list-item" @click="handleTitleClick">
      <div class="overh list-title">{{ data.noticeName }}</div>
      <div class="list-content">
        <div class="overh content-title">{{ data.noticeTypeName || '' }}</div>
        <div class="content-time">{{ formatTime(data.noticeTime) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AdsVue from "@components/sys/ads";
import {toTime} from "../assets/js/news.js";
import {mapGetters} from "vuex";

export default {
  components: {
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      info: "",
      dialogVisible: false,
      label_style: {
        width: "150px",
      },
      isLogin: false,
    };
  },
  methods: {
    formatTime(time) {
      return toTime(time)
    },
    handleTitleClick() {
      if (!this.isLogin) {
        this.$store.commit('userinfo/upateLoginState', {
          show: true,
          callback: () => {
            this.$router.push({
              path: "/notice-detail",
              query: {
                id: this.data.noticeId,
              }
            })
          }
        })
      } else {
        this.$router.push({
          path: "/notice-detail",
          query: {
            id: this.data.noticeId,
          }
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      nickname: "userinfo/getNickname",
    }),
  },
  mounted() {
    this.isLogin = !!this.nickname
  },
};
</script>

<style scoped lang="scss">
.list-item {
  cursor: pointer;
  margin-top: 11px;

  .list-title {
    font-weight: bold;
  }

  .list-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    font-size: 14px;
    color: #111111;
    line-height: 38px;

    .content-title {
      color: #666666;
    }

    .content-time {
      white-space: nowrap;
      margin-left: 56px;
      color: #666666;
    }
  }
}
</style>
